import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { Box } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import {
  fetchLocations,
  addLocation,
  updateLocation,
  deleteLocation
} from "../../services/locationService";

import AppHeader from "../../components/AppHeader";

const LocationsPage = ({setIsLoggedIn}) => {
  const [locations, setLocations] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState("");
  

  const [form, setForm] = useState({
    location_name: "",
    latitude: "",
    longitude: "",
    radius_meters: 50
  });

  const load = async () => {
    const res = await fetchLocations();
    const list =
      Array.isArray(res)
        ? res
        : Array.isArray(res?.rows)
          ? res.rows
          : Array.isArray(res?.locations)
            ? res.locations
            : [];
    setLocations(list);
  };

  useEffect(() => {
    load();
  }, []);

  const handleOpenAdd = () => {
    setEditing(null);
    setForm({
      location_name: "",
      latitude: "",
      longitude: "",
      radius_meters: 50
    });
    setOpen(true);
  };

  const handleOpenEdit = (loc) => {
    setEditing(loc.id);
    setForm({
      location_name: loc.location_name,
      latitude: loc.latitude,
      longitude: loc.longitude,
      radius_meters: loc.radius_meters
    });
    setOpen(true);
  };

  const handleSave = async () => {
    if (editing) {
      await updateLocation(editing, form);
    } else {
      await addLocation(form);
    }
    setOpen(false);
    load();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this location?")) {
      await deleteLocation(id);
      load();
    }
  };

  const filteredLocations = locations.filter(loc =>
    loc.location_name.toLowerCase().includes(search.toLowerCase())
  );

  
  return (
    <div>
      {/* PAGE HEADER */}
      <AppHeader onLogout={() => {
        localStorage.removeItem("token"); // Optional: Extra safety to ensure token is gone
        setIsLoggedIn(false);
      }} />
      <Box
        sx={{
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#e8f5e9",
          color: "#1b5e20"
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold", marginLeft: "45px" }}>
          Locations Setup
        </Typography>

        <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
          <TextField
            label="Search Locations"
            variant="outlined"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            sx={{ width: "250px" }}
          />

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpenAdd}
            sx={{
              backgroundColor: "#ffffff",
              color: "#1b5e20",
              fontWeight: "bold",
              "&:hover": { backgroundColor: "#e8e8e8" }
            }}
          >
            Add Location
          </Button>
        </div>
      </Box>

      {/* TABLE */}
      <TableContainer
        component={Paper}
        sx={{
          mt: 2,
          p: 2,
          mx: "auto",
          width: "90%",
          maxWidth: "1400px",
          borderRadius: "8px"
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Name</b></TableCell>
              <TableCell><b>Latitude</b></TableCell>
              <TableCell><b>Longitude</b></TableCell>
              <TableCell><b>Radius (m)</b></TableCell>
              <TableCell><b>Actions</b></TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredLocations.map((loc) => (
              <TableRow key={loc.id}>
                <TableCell>{loc.location_name}</TableCell>
                <TableCell>{loc.latitude}</TableCell>
                <TableCell>{loc.longitude}</TableCell>
                <TableCell>{loc.radius_meters}</TableCell>
                <TableCell>
                  <IconButton color="primary" onClick={() => handleOpenEdit(loc)}>
                    <EditIcon />
                  </IconButton>
                  <IconButton color="error" onClick={() => handleDelete(loc.id)}>
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {filteredLocations.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No locations found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* ADD/EDIT DIALOG */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>
          {editing ? "Edit Location" : "Add Location"}
        </DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            label="Location Name"
            margin="dense"
            value={form.location_name}
            onChange={(e) => setForm({ ...form, location_name: e.target.value })}
          />
          <TextField
            fullWidth
            label="Latitude"
            margin="dense"
            value={form.latitude}
            onChange={(e) => setForm({ ...form, latitude: e.target.value })}
          />
          <TextField
            fullWidth
            label="Longitude"
            margin="dense"
            value={form.longitude}
            onChange={(e) => setForm({ ...form, longitude: e.target.value })}
          />
          <TextField
            fullWidth
            label="Radius (meters)"
            margin="dense"
            type="number"
            value={form.radius_meters}
            onChange={(e) => setForm({ ...form, radius_meters: e.target.value })}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}
export default LocationsPage;